query GetUser($id: ID!) {
  user(id: $id) {
    id
    firstName
    surname
    email
    hasContactLink
    signingCompleted
    companyLogoUrl
    avatarUrl
    quote
    bio
    fullTitleOverride
    salesforceId
    memberPageVisibility
    admin
    permissions
    employeePermissions {
      id
      name
      permissionType
    }
    userPermissions {
      id
      name
      permissionType
    }
    featureFlags
    displayPriority
    twoFactorEnabled
    isMemberAppUser
    isGranteePortalUser
    archived
    employee {
      id
      name
      worksAtFp
    }
  }
}
